import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastService } from './services/toast/toast.service';
import { TranslationHelperService } from './services/translation-helper/translation-helper.service';
import { AuthService } from 'src/app/_services/auth.service';

import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { AnalyticsConstants } from './global-constants/analytics'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService]
})

export class AppComponent implements OnInit {
  private roles: string[] = [];
  isLoggedin: boolean = false;
  isSuperAdmin: boolean = false;
  constructor(
    private router: Router,
    private translationHelperService: TranslationHelperService,
    private toastMessageService: ToastService,
    private messageService: MessageService,
    private authService: AuthService,
    private analytics: AngularFireAnalytics,
  ) { }

  ngOnInit(): void {
    this.initTranslate();
    this.setUpToastListener();
    this.authService.isLoggedIn$.subscribe((result) =>
      this.isLoggedin = result
    );
    this.authService.isSuperAdmin$.subscribe((result) =>
      this.isSuperAdmin = result
    );
    this.authService.autoLogin();
  }

  private initTranslate(): void {
    this.translationHelperService.initializeTranslate();
  }

  private setUpToastListener(): void {
    this.toastMessageService.toastMessages.subscribe(message => {
      this.messageService.add(message);
    });
  }

  ngAfterViewInit() {
    this.analytics.logEvent(AnalyticsConstants.first_open);
  }
}
